import * as yup from 'yup';
import {
  RiskAssessmentSchema,
  ScaleRatingSchema,
  ScaleRatingSuggestionSchema,
  SuggestionSchema,
} from '../../../common';

// Validation Schema for the DecubitusRiskForm
export const DecubitusRiskFormSchema = yup.object({
  positionChangeBed: ScaleRatingSchema,
  positionChangeSit: ScaleRatingSchema,
  handlingMoisture: ScaleRatingSchema,
  handlingShearForce: ScaleRatingSchema,
  handlingPressureAids: ScaleRatingSchema,
  riskAssessment: RiskAssessmentSchema,
});
export type IDecubitusRiskForm = yup.InferType<typeof DecubitusRiskFormSchema>;

export const DecubitusRiskSuggestionSchema = yup.object({
  positionChangeBed: ScaleRatingSuggestionSchema.nullable(),
  positionChangeSit: ScaleRatingSuggestionSchema.nullable(),
  handlingMoisture: ScaleRatingSuggestionSchema.nullable(),
  handlingShearForce: ScaleRatingSuggestionSchema.nullable(),
  handlingPressureAids: ScaleRatingSuggestionSchema.nullable(),
  noDecubitusRiskDueTo: SuggestionSchema.nullable(),
  decubitusRiskDueTo: SuggestionSchema.nullable(),
});
export type IDecubitusRiskSuggestion = yup.InferType<typeof DecubitusRiskSuggestionSchema>;

// Validation Schema for Creating a DecubitusRiskForm
export const CreateDecubitusRiskFormSchema = yup
  .object({
    residentId: yup.string().required(),
  })
  .concat(DecubitusRiskFormSchema);
export type ICreateDecubitusRiskForm = yup.InferType<typeof CreateDecubitusRiskFormSchema>;

// Validation Schema for Updating a DecubitusRiskForm
export const UpdateDecubitusRiskFormSchema = yup
  .object({
    id: yup.string().required(),
  })
  .concat(DecubitusRiskFormSchema);
export type IUpdateDecubitusRiskForm = yup.InferType<typeof UpdateDecubitusRiskFormSchema>;
